import React from 'react';
import Table from 'react-bootstrap/Table';
import { DateTime } from 'luxon';
import { CentreServiceScolaire } from '../../../../../../common/src/entities';
import { Button } from 'react-bootstrap/lib/InputGroup';

interface DynamicTableCSSProps {
    data: CentreServiceScolaire;
    title: string;
}
function formatDate(timestampISO) {
    const dateTime = DateTime.fromISO(timestampISO, { zone: 'utc' });
    return dateTime.toFormat('dd-MMM-yy (EEE)').replaceAll('.', '');
}

const DynamicTableContact: React.FC<DynamicTableCSSProps> = ({ data, title }) => {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Courriel:</th>
                        <th>Lieu:</th>
                    </tr>
                </thead>
                <tbody>
                    <td>{data.email}</td>
                    <td>{data.lieux?.name}</td>
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTableContact;
